<template>
  <div class="static-integrations-section mt-8 pt-8 border-t border-slate-300 dark:border-zinc-700" data-testid="apps-section">
    <h2 class="text-xl font-semibold mb-3">Apps</h2>
    <p class="text-sm text-zinc-600 dark:text-zinc-400 mb-6">Install our Zight apps into the different tools you already use in your day-to-day operations.</p>

    <div
      v-if="staticIntegrationsLoading && !sortedStaticIntegrations.length"
      class="static-integrations-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      data-testid="apps-section-skeleton"
    >
      <div v-for="index in 6" :key="index" class="h-40 rounded-lg bg-zinc-200 dark:bg-zinc-800 animate-pulse" />
    </div>
    <div v-else class="static-integrations-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" data-testid="apps-grid">
      <StaticIntegrationCard
        v-for="integration in sortedStaticIntegrations"
        :key="integration.name"
        :integration="integration"
        @track-click="handleStaticIntegrationClick"
        @request-integration="handleRequestEnable"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import StaticIntegrationCard from '../cards/StaticIntegrationCard.vue';
import { useIntegrationStore } from '../../store/useIntegrationStore';
import { useIntegrationActions } from '../../composables/useIntegrationActions';

const integrationStore = useIntegrationStore();
const { handleStaticIntegrationClick, handleRequestEnable } = useIntegrationActions();

const { sortedStaticIntegrations, staticIntegrationsLoading } = storeToRefs(integrationStore);

onMounted(() => {
  if (!sortedStaticIntegrations.value.length) {
    integrationStore.fetchStaticIntegrations();
  }
});
</script>

<style scoped>
.static-integrations-grid {
  @apply grid gap-6 mt-4;
}
</style>
